import React, { useState } from 'react';
import styled from 'styled-components';
import PlainButton from '../PlainButton';
import BooleanFilter from '../FilterableList/Filters/BooleanFilter';
import { green } from '../../styles/constants';

const TooltipBody = styled.div`
  background-color: white;
  padding: 1.5rem;
  
  @media (min-width: 320px) { 
    min-width: 300px;
   }
`;

const TooltipTitle = styled.span`  
  font-weight: 600;
  font-size: 1.25rem;
`;

const TooltipFooter = styled.div`  
  padding-top: 1rem;
`;

const NextButton = styled(PlainButton)`
  font-weight: 600;
  color: ${green};
`;

const PreviousButton = styled(PlainButton)`
  font-weight: 600;
  opacity: 0.6;
`;

const Tooltip = ({
  continuous,
  index,
  step,
  size,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
}) => {
  let initialCheckboxClickedState = false
  const showGuidedTour = localStorage.getItem('showGuidedTour');
  if (showGuidedTour === 'false') {
    initialCheckboxClickedState = true
  }

  const [checkboxClicked, setCheckboxClicked] = useState(initialCheckboxClickedState);
  const isLastStep = size === index + 1;

  const handleDontShowClick = (e) => {
    setCheckboxClicked((prevState) => {
      const newCheckboxClickecValue = !prevState;
      localStorage.setItem('showGuidedTour', !newCheckboxClickecValue);
      return newCheckboxClickecValue;
    });
  };

  return (
    <TooltipBody {...tooltipProps}>
      {step.title && <TooltipTitle>{step.title}</TooltipTitle>}
      <div>
        {step.content}
      </div>
      <TooltipFooter>
        <div className="d-flex">
          {index > 0 && (
          <PreviousButton className="mr-2" id="back" {...backProps}>
            Terug
          </PreviousButton>
          )}
          <BooleanFilter
            handleClick={handleDontShowClick}
            label="Selecteer dit om de volgende sessie de uitleg te verbergen"
            selected={checkboxClicked}
            className="mr-auto"
          />
          {isLastStep ? (
            <>
              <NextButton {...primaryProps} id="next">
                Sluiten
              </NextButton>
            </>
          ) : (
            <NextButton id="next" {...primaryProps}>
              Volgende
            </NextButton>
          )}
        </div>
      </TooltipFooter>
    </TooltipBody>
  );
};

export default Tooltip;
